const TvEventControl = () => null;

export default TvEventControl;
